<div class="p-6">
  <!-- Projects Table -->
  <p-table
    #table
    [value]="projects()"
    [loading]="loading()"
    [paginator]="true"
    [rows]="queryParams().limit"
    [totalRecords]="totalRecords()"
    [first]="first"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [stripedRows]="true"
    [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
    (onPage)="onPageChange($event)"
  >
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex">
        <div class="flex gap-2">
          <p-button
            label="{{ 'projects.addProject' | translate }}"
            icon="pi pi-plus"
            severity="success"
            [disabled]="loading()"
            [loading]="loading()"
            (onClick)="addProject()"
          >
          </p-button>
        </div>
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            #searchInput
            pInputText
            type="text"
            [formControl]="searchControl"
            [placeholder]="'projects.searchPlaceholder' | translate"
          />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" class="w-4/5">
          {{ 'projects.headers.name' | translate }}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th class="w-1/5">{{ 'projects.headers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-project>
      <tr>
        <td>{{ project.name }}</td>
        <td>
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              size="small"
              [disabled]="loading()"
              [ariaLabel]="'projects.edit' | translate"
              (onClick)="editProject(project)"
            >
            </p-button>
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              size="small"
              [disabled]="loading()"
              [ariaLabel]="'projects.delete' | translate"
              (onClick)="deleteProject(project)"
            >
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-briefcase text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'projects.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>
